<template>
    <div class="agreement-page">
        <div class="header">
            <i class="el-icon-arrow-left back-btn" @click="goBack"></i>
            <h1 class="title">电子渠道开户服务协议</h1>
        </div>
        <div class="content">
            <img src="@/assets/accountService0.png" style="width: 100%; height: auto; display: block;" alt="电子渠道开户服务协议">
            <img src="@/assets/accountService1.png" style="width: 100%; height: auto; display: block;" alt="电子渠道开户服务协议">
            <img src="@/assets/accountService2.png" style="width: 100%; height: auto; display: block;" alt="电子渠道开户服务协议">
            <img src="@/assets/accountService3.png" style="width: 100%; height: auto; display: block;" alt="电子渠道开户服务协议">
        </div>
    </div>
</template>

<script>
export default {
  name: 'AccountServicePage',
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.agreement-page {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);

  .back-btn {
    font-size: 24px;
    color: #333;
    cursor: pointer;
    padding: 10px;
    margin-left: -10px;
    
    &:active {
      opacity: 0.6;
    }
  }

  .title {
    flex: 1;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin: 0;
    padding: 0 40px 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.content {
  padding-top: 50px;
}
</style>    